@file:UseContextualSerialization(LocalDate::class)

package pl.finn.forms.fk02

import io.kvision.types.LocalDate
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization

@Serializable
data class Fk02Form(
  var numerRPP: String? = null,
  var terminPlatnosci: LocalDate? = null,
  var naPodstawie: String? = null,
  var zRachunku: String? = null,
  var naRachunek: String? = null,
  var posiadaSwiftIkodKraju: Boolean = false,
  var numerSWIFT: String? = null,
  var kodKraju: String? = null,
  var nazwaOdbiorcy: String? = null,
  var adresOdbiorcy: String? = null,
  var kwotaPrzelewu: String? = null,
  var czyWalutaInnaNizPLN: String? = null,
  var walutaInnaNizPLN: String? = null,
  var slownie: String? = null,
  var tytulem: String? = null,
  var czyObciazaPlanFinansowy: String? = null,

  val realizacjaBudzetu: ArrayList<RealizacjaBudzetu> = arrayListOf<RealizacjaBudzetu>(),
  val uwagi: ArrayList<Uwagi> = arrayListOf<Uwagi>()

)

@Serializable
data class Fk02FormData(
  val form: Fk02Form,
  val url: String,
  val token: String?
)

@Serializable
data class RealizacjaBudzetu(
  var nrCruUmowyLubNrWnioskuZd: String? = null,
  var kwota: String? = null,
  var dzial: String? = null,
  var rozdzial: String? = null,
  var paragraf: String? = null,
  var zadanieBudzetowe: String? = null,
  var zrodloFinansowania: String? = null,
  var obiektBudzetowy: String? = null
)

@Serializable
data class Uwagi(
  var uwagi: String? = null
)